// extracted by mini-css-extract-plugin
export default {"root":"BlockedTaskMessage_root__I1h9f","openTaskButton":"BlockedTaskMessage_openTaskButton__tiXmY"};